import { AdviceState } from '../models';
import { AdviceActions, AdviceActionTypes } from './actions';

export const initialAdviceState = {} as AdviceState;

// add switch cased to the reducer for every action
// or combine reducers from the reducers subfolder right here
export const adviceReducer = (
  state: AdviceState = initialAdviceState,
  action: AdviceActions,
): AdviceState => {
  switch (action.type) {
  case AdviceActionTypes.SetSelectedCropFieldIds: {
    return {
      ...state,
      selectedCropFieldIds: [...action.cropFieldIds],
    };
  }

  case AdviceActionTypes.SetTemplate: {
    return {
      ...state,
      template: { ...action.template },
    };
  }

  case AdviceActionTypes.SetExecutedTreatments: {
    return {
      ...state,
      executedTreatments: action.executedTreatments,
    };
  }

  case AdviceActionTypes.SetNitrogenCalculationSettingToggles: {
    return {
      ...state,
      nitrogenCalculationSettingToggles: action.nitrogenCalculationSettingToggles,
    };
  }

  case AdviceActionTypes.SetNitrogenCalculationSettingTogglesByAdvices: {
    return {
      ...state,
      nitrogenCalculationSettingTogglesByAdvices: action.nitrogenCalculationSettingToggles,
    };
  }

  case AdviceActionTypes.SetRecommendedNutrientQuantityByAdviceIds: {
    return {
      ...state,
      recommendedNutrientQuantityWithIds: action.recommendedNutrientQuantityWithIds,
    };
  }

  case AdviceActionTypes.SetLatestSoilAnalysis: {
    return {
      ...state,
      latestSoilAnalysis: action.latestSoilAnalysis,
    };
  }

  case AdviceActionTypes.SetOrganicMatterReport: {
    return {
      ...state,
      organicMatterReport: action.organicMatterReport,
    };
  }

  case AdviceActionTypes.ClearOrganicMatterReport: {
    return {
      ...state,
      organicMatterReport: null,
    };
  }

  case AdviceActionTypes.SetFertilizationSetting: {
    return {
      ...state,
      fertilizationSetting: action.fertilizationSetting,
    };
  }

  case AdviceActionTypes.SetFertilizationSettings: {
    return {
      ...state,
      fertilizationSettings: action.fertilizationSettings,
    };
  }

  case AdviceActionTypes.SaveFertilizationSettingSuccess: {
    if (!action.fertilizationSetting) {
      return state;
    }

    return {
      ...state,
      fertilizationSettings: state.fertilizationSettings?.map((setting) =>
        setting.adviceId === action.fertilizationSetting.adviceId
          ? { ...setting, ...action.fertilizationSetting }
          : setting,
      ),
      fertilizationSetting:
        state.fertilizationSetting?.adviceId === action.fertilizationSetting.adviceId
          ? { ...state.fertilizationSetting, ...action.fertilizationSetting }
          : state.fertilizationSetting,
    };
  }

  case AdviceActionTypes.PrefillCropField: {
    return {
      ...state,
      isPrefilling: action.isPrefilling,
    };
  }

  case AdviceActionTypes.SetCustomerFertilizerStock: {
    return {
      ...state,
      customerFertilizerStock: action.customerFertilizerStock,
    };
  }

  case AdviceActionTypes.UpdateExpectedCropYield: {
    const { adviceId, expectedCropYield } = action;
    const updatedFertilizationSettings = state.fertilizationSettings?.map((setting) => {
      if (setting.adviceId === adviceId) {
        return {
          ...setting,
          expectedCropYield,
        };
      }
      return setting;
    }) || null;

    return {
      ...state,
      fertilizationSettings: updatedFertilizationSettings,
      fertilizationSetting: state.fertilizationSetting && state.fertilizationSetting.adviceId === adviceId
        ? { ...state.fertilizationSetting, expectedCropYield }
        : state.fertilizationSetting,
    };
  }

  case AdviceActionTypes.UpdateExpectedCropYieldSuccess: {
    return state;
  }

  case AdviceActionTypes.UpdateExpectedCropYieldFailure: {
    return state;
  }

  default:
    return state;
  }
};
